import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { paths } from "helpers/paths";
import { rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import policy from "policies";
import React from "react";
import { Link } from "react-router-dom";

class CounterpartyGroups extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                Cell: ({
                    value,
                    row: {
                        original: { id },
                    },
                }) =>
                    policy("user", { user: { roles: this.props.roles } }).isTruckingOrganizationAdmin() && id ? (
                        <Link to={paths.counterpartyGroupsShow(id)}>{value}</Link>
                    ) : (
                        value
                    ),
            },
            { Header: "Кол-во контрагентов", accessor: "count", filterable: false, sortable: false },
        ];
    }

    renderCreateButton = () => {
        const { modal, mergeParams, roles } = this.props;
        if (!policy("user", { user: { roles } }).isTruckingOrganizationAdmin()) {
            return;
        }
        const action = () =>
            modal({
                name: "counterpartyGroupForm",
                title: "Создание группы",
                mergeParams,
            });
        return (
            <a className="btn btn-brand btn-sm" onClick={action}>
                Создать группу
            </a>
        );
    };

    renderListComponent = () => {
        return <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
    };
}

export default tableContainer(CounterpartyGroups, "counterparty-groups");
